import { Say } from "../widgets/Say";

/** wrapper around <Say> that highlights an issue with pronunciation */
export function Issue(props: { children: string }) {
  return <Say textColor="rgb(200,100,100)">{props.children}</Say>;
}

export function Base(props: { children: string }) {
  return <Say textColor="rgb(184, 129, 10)">{props.children}</Say>;
}
